module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
      return e[t];
    }.bind(null, o));
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 1);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.DBMode = t.DBOperations = t.CreateObjectStore = t.openDatabase = void 0;
  var r,
      o = n(4),
      a = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

  function i(e, t, n) {
    return new Promise(function (r, o) {
      var i,
          c = a.open(e, t);
      c.onsuccess = function (e) {
        i = c.result, r(i);
      }, c.onerror = function (e) {
        o("IndexedDB error: " + c.error);
      }, "function" == typeof n && (c.onupgradeneeded = function (e) {
        n(e, i);
      });
    });
  }

  t.openDatabase = i, t.CreateObjectStore = function (e, t, n) {
    var r = a.open(e, t);
    r.onupgradeneeded = function (e) {
      var t = e.target.result;
      n.forEach(function (e) {
        if (!t.objectStoreNames.contains(e.store)) {
          var n = t.createObjectStore(e.store, e.storeConfig);
          e.storeSchema.forEach(function (e) {
            n.createIndex(e.name, e.keypath, e.options);
          });
        }
      }), t.close();
    }, r.onsuccess = function (e) {
      e.target.result.close();
    };
  }, t.DBOperations = function (e, t, n) {
    return {
      add: function (a, c) {
        return new Promise(function (u, s) {
          i(e, t).then(function (e) {
            o.createTransaction(e, o.optionsGenerator(r.readwrite, n, s, u)).objectStore(n).add(a, c).onsuccess = function (e) {
              c = e.target.result, u(c);
            };
          });
        });
      },
      getByID: function (a) {
        return new Promise(function (c, u) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, u), o.createTransaction(e, o.optionsGenerator(r.readonly, n, u, c)).objectStore(n).get(+a).onsuccess = function (e) {
              c(e.target.result);
            };
          });
        });
      },
      getAll: function () {
        return new Promise(function (a, c) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, c);
            var t = o.createTransaction(e, o.optionsGenerator(r.readonly, n, c, a)).objectStore(n).getAll();
            t.onerror = function (e) {
              c(e);
            }, t.onsuccess = function (e) {
              var t = e.target.result;
              a(t);
            };
          });
        });
      },
      update: function (a, c) {
        return new Promise(function (u, s) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, s);
            var t = o.createTransaction(e, o.optionsGenerator(r.readwrite, n, s, u)),
                i = t.objectStore(n);
            t.oncomplete = function (e) {
              u(e);
            }, i.put(a, c);
          });
        });
      },
      deleteRecord: function (a) {
        return new Promise(function (c, u) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, u), o.createTransaction(e, o.optionsGenerator(r.readwrite, n, u, c)).objectStore(n).delete(a).onsuccess = function (e) {
              c(e);
            };
          });
        });
      },
      clear: function () {
        return new Promise(function (a, c) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, c);
            var t = o.createTransaction(e, o.optionsGenerator(r.readwrite, n, c, a));
            t.objectStore(n).clear(), t.oncomplete = function (e) {
              a();
            };
          });
        });
      },
      openCursor: function (a, c) {
        return new Promise(function (u, s) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, s), o.createTransaction(e, o.optionsGenerator(r.readonly, n, s, u)).objectStore(n).openCursor(c).onsuccess = function (e) {
              a(e), u();
            };
          });
        });
      },
      getByIndex: function (a, c) {
        return new Promise(function (u, s) {
          i(e, t).then(function (e) {
            o.validateBeforeTransaction(e, n, s), o.createTransaction(e, o.optionsGenerator(r.readonly, n, s, u)).objectStore(n).index(a).get(c).onsuccess = function (e) {
              u(e.target.result);
            };
          });
        });
      }
    };
  }, function (e) {
    e.readonly = "readonly", e.readwrite = "readwrite";
  }(r = t.DBMode || (t.DBMode = {}));
}, function (e, t, n) {
  "use strict";

  var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
    void 0 === r && (r = n), Object.defineProperty(e, r, {
      enumerable: !0,
      get: function () {
        return t[n];
      }
    });
  } : function (e, t, n, r) {
    void 0 === r && (r = n), e[r] = t[n];
  }),
      o = this && this.__exportStar || function (e, t) {
    for (var n in e) "default" === n || t.hasOwnProperty(n) || r(t, e, n);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = n(2);
  Object.defineProperty(t, "AccessDB", {
    enumerable: !0,
    get: function () {
      return a.AccessDB;
    }
  }), Object.defineProperty(t, "IndexedDB", {
    enumerable: !0,
    get: function () {
      return a.IndexedDB;
    }
  }), o(n(5), t);
}, function (e, t, n) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, n, r) {
    return new (n || (n = Promise))(function (o, a) {
      function i(e) {
        try {
          u(r.next(e));
        } catch (e) {
          a(e);
        }
      }

      function c(e) {
        try {
          u(r.throw(e));
        } catch (e) {
          a(e);
        }
      }

      function u(e) {
        var t;
        e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
          e(t);
        })).then(i, c);
      }

      u((r = r.apply(e, t || [])).next());
    });
  },
      a = this && this.__generator || function (e, t) {
    var n,
        r,
        o,
        a,
        i = {
      label: 0,
      sent: function () {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return a = {
      next: c(0),
      throw: c(1),
      return: c(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
      return this;
    }), a;

    function c(a) {
      return function (c) {
        return function (a) {
          if (n) throw new TypeError("Generator is already executing.");

          for (; i;) try {
            if (n = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;

            switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {
              case 0:
              case 1:
                o = a;
                break;

              case 4:
                return i.label++, {
                  value: a[1],
                  done: !1
                };

              case 5:
                i.label++, r = a[1], a = [0];
                continue;

              case 7:
                a = i.ops.pop(), i.trys.pop();
                continue;

              default:
                if (!(o = i.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                  i = 0;
                  continue;
                }

                if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                  i.label = a[1];
                  break;
                }

                if (6 === a[0] && i.label < o[1]) {
                  i.label = o[1], o = a;
                  break;
                }

                if (o && i.label < o[2]) {
                  i.label = o[2], i.ops.push(a);
                  break;
                }

                o[2] && i.ops.pop(), i.trys.pop();
                continue;
            }

            a = t.call(e, i);
          } catch (e) {
            a = [6, e], r = 0;
          } finally {
            n = o = 0;
          }

          if (5 & a[0]) throw a[1];
          return {
            value: a[0] ? a[1] : void 0,
            done: !0
          };
        }([a, c]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.AccessDB = t.IndexedDB = void 0;
  var c = i(n(3)),
      u = n(0),
      s = c.default.createContext({
    db: null,
    name: null,
    version: null
  }),
      f = s.Provider,
      l = s.Consumer;
  t.IndexedDB = function (e) {
    var t = this,
        n = e.name,
        r = e.version,
        i = e.children;
    return e.objectStoresMeta.forEach(function (e) {
      return o(t, void 0, void 0, function () {
        return a(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, u.openDatabase(n, r, function (t) {
                var n = t.currentTarget.result.createObjectStore(e.store, e.storeConfig);
                e.storeSchema.forEach(function (e) {
                  n.createIndex(e.name, e.keypath, e.options);
                });
              })];

            case 1:
              return t.sent(), [2];
          }
        });
      });
    }), c.default.createElement(f, {
      value: {
        db: null,
        name: n,
        version: r
      }
    }, i);
  }, t.AccessDB = function (e) {
    var t = e.children,
        n = e.objectStore;
    return c.default.createElement(l, null, function (e) {
      var o = e.db,
          a = e.name,
          i = e.version;
      return t(r({
        db: o
      }, u.DBOperations(a, i, n)));
    });
  };
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    return e.objectStoreNames.contains(t);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.optionsGenerator = t.createTransaction = t.validateBeforeTransaction = t.validateStoreName = void 0, t.validateStoreName = r, t.validateBeforeTransaction = function (e, t, n) {
    e || n("You need to use the openDatabase function to create a database before you query it!"), r(e, t) || n("objectStore does not exists: " + t);
  }, t.createTransaction = function (e, t) {
    var n = e.transaction(t.storeName, t.dbMode);
    return n.onerror = t.error, n.oncomplete = t.complete, n.onabort = t.abort, n;
  }, t.optionsGenerator = function (e, t, n, r) {
    return {
      storeName: t,
      dbMode: e,
      error: function (e) {
        n(e);
      },
      complete: function (e) {
        r();
      },
      abort: function (e) {
        n(e);
      }
    };
  };
}, function (e, t, n) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.useIndexedDB = t.initDB = void 0;
  var o = n(0),
      a = {
    version: null,
    name: null
  };
  t.initDB = function (e) {
    var t = e.name,
        n = e.version,
        r = e.objectStoresMeta;
    a.name = t, a.version = n, Object.freeze(a), o.CreateObjectStore(t, n, r);
  }, t.useIndexedDB = function (e) {
    if (!a.name || !a.version) throw new Error("Please, initialize the DB before the use.");
    return r({}, o.DBOperations(a.name, a.version, e));
  };
}]);